import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export interface Tournament {
  name: string;
  date: string;
  id: string;
}

export interface TournamentHookReturn {
  tournaments: Tournament[];
  currentTournament: Tournament | null;
  tournamentDialogOpen: boolean;
  newTournamentName: string;
  newTournamentDate: Dayjs | null;
  handleCreateTournament: () => void;
  handleCreateTournamentConfirm: () => void;
  handleCreateTournamentCancel: () => void;
  handleSelectTournament: (tournament: Tournament) => void;
  setNewTournamentName: (name: string) => void;
  setNewTournamentDate: (date: Dayjs | null) => void;
  setTournaments: (tournaments: Tournament[]) => void;
}

export const useTournament = (): TournamentHookReturn => {
  const [tournaments, setTournaments] = useState<Tournament[]>([]);
  const [currentTournament, setCurrentTournament] = useState<Tournament | null>(null);
  const [tournamentDialogOpen, setTournamentDialogOpen] = useState(false);
  const [newTournamentName, setNewTournamentName] = useState('');
  const [newTournamentDate, setNewTournamentDate] = useState<Dayjs | null>(dayjs());

  const handleCreateTournament = () => {
    setTournamentDialogOpen(true);
  };

  const handleCreateTournamentConfirm = () => {
    if (newTournamentName.trim() && newTournamentDate) {
      const newTournament: Tournament = {
        name: newTournamentName.trim(),
        date: newTournamentDate.format('YYYY-MM-DD'),
        id: `tournament-${Date.now()}`
      };
      setTournaments(prev => [...prev, newTournament]);
      setCurrentTournament(newTournament);
      setTournamentDialogOpen(false);
      setNewTournamentName('');
      setNewTournamentDate(dayjs());
    }
  };

  const handleCreateTournamentCancel = () => {
    setTournamentDialogOpen(false);
    setNewTournamentName('');
    setNewTournamentDate(dayjs());
  };

  const handleSelectTournament = (tournament: Tournament) => {
    setCurrentTournament(tournament);
  };

  return {
    tournaments,
    currentTournament,
    tournamentDialogOpen,
    newTournamentName,
    newTournamentDate,
    handleCreateTournament,
    handleCreateTournamentConfirm,
    handleCreateTournamentCancel,
    handleSelectTournament,
    setNewTournamentName,
    setNewTournamentDate,
    setTournaments,
  };
};
